module.exports = __webpack_public_path__ + "img/CONSIGNET_LOGO.4100524c.png";